/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityMetadataModel } from '../../models/entity-metadata-model';

export interface ApiAdminFhirIdHealthCareServicesGet$Params {
  fhirId: string;
}

export function apiAdminFhirIdHealthCareServicesGet(http: HttpClient, rootUrl: string, params: ApiAdminFhirIdHealthCareServicesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<EntityMetadataModel>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminFhirIdHealthCareServicesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<EntityMetadataModel>>;
    })
  );
}

apiAdminFhirIdHealthCareServicesGet.PATH = '/api/Admin/{fhirId}/HealthCareServices';
